export default "__VITE_ASSET__416c1f68__"